const PAYMENT_METHODS_SUPPORTED_BY_STRIPE = ['uk_bank_transfer', 'iban_bank_transfer'] as const;

export default PAYMENT_METHODS_SUPPORTED_BY_STRIPE;
